module.exports = __webpack_public_path__ + "static/media/ic-plus.ae0952c1.svg";